import React from 'react';
export default function Indentation(props) {
  return /*#__PURE__*/React.createElement("div", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: "fabric-editor-block-mark fabric-editor-indentation-mark",
    "data-level": props.level
  }, props.children);
}